/**
 * 获取根电机域名
 */
function g_getRootDomain() {
  if (window.location.hostname === 'localhost') return 'localhost'
  return '.' + window.location.hostname.split('.').slice(-2).join('.')
}

/**
 * 检查字符串是否是JSON
 * @param {*} str
 */
function g_checkIsJSON(str) {
  if (typeof str === 'string') {
    try {
      var obj = JSON.parse(str)
      if (typeof obj === 'object' && obj) {
        return true
      } else {
        return false
      }
    } catch (e) {
      return false
    }
  }
  return false
}

/**
 *  获取cookie
 * @param {String} name
 * @param {Boolean} decode
 */
function g_getCookie(name, decode = true) {
  var arr
  var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  if ((arr = document.cookie.match(reg))) {
    let ls = unescape(arr[2])
    if (decode) {
      ls = decodeURIComponent(ls)
    }
    if (g_checkIsJSON(ls)) {
      ls = JSON.parse(ls)
    }
    return ls
  } else {
    return ''
  }
}

/**
 * 添加cookie
 * @param {String} name
 * @param {String} value
 * @param {Number} day 默认30天
 * @param {String} domain 默认子域名
 * @param {String} path 默认根目录
 */
function g_setCookie(name, value, day = 30, domain, path = '/') {
  const exp = new Date()
//   exp.addDays(day)
  exp.setDate(exp.getDate() + day)
  domain = domain || window.location.hostname
  if (typeof value !== 'string') {
    value = JSON.stringify(value)
  }
  document.cookie = `${name}=${value};domain=${domain};expires=${exp.toUTCString()};path=${path}`
}

/**
 * 添加根域名cookie
 * @param {String} name
 * @param {String} value 含有特殊字符串';、,、=' 需要在外层进行encodeURIComponent,否则取不出来
 * @param {Number} day 默认30天
 * @param {String} path 默认根目录
 */
function g_setRootDomainCookie (name, value, day = 30, path = '/') {
  const rootDomain = g_getRootDomain()
  g_setCookie(name, value, day, rootDomain, path)
}

/**
 * 删除根域名cookie
 * @param {String} name
 * @param {String} path 默认根目录
 */
function g_delRootDomainCookie (name, path = '/') {
  const rootDomain = g_getRootDomain()
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=${path};domain=${rootDomain}`
}

function getRecaptchaToken(actionType) {
    try {
        return grecaptcha.execute('6Lfkjd4UAAAAAD7bZF_ypN7P1wVoYHd7TYoqbmJt', {action: actionType}).then(function(token) {
          return token;
        }).catch(e => {
        return ''
        });
    } catch (e) {
        console.error(e)
        return Promise.resolve('')
    }
}

function g_getRecaptchaToken(actionType) {
  return new Promise((resolve, reject) => {
    function start() {
      resolve('')

      // setTimeout(() => {
      //   if(!grecaptcha.execute) {
      //     start()
      //     return
      //   }
      //   getRecaptchaToken(actionType).then(res => {
      //     resolve(res)
      //   }).catch(e => {
      //     reject(e)
      //   })
      // }, 500)
    }
    start()
  })
}